var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.course)?_c('div',{staticClass:"DashboardCourseDetails"},[_c('CourseToc',{staticClass:"tocSection",attrs:{"course-id":_vm.courseId}}),_c('About',{attrs:{"popup-type":"theory","lifeskill-id":_vm.course.lifeskillNumber}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }